export default __webpack_public_path__ + "static/media/veth2.4d368f5e.svg";